module.exports = __webpack_public_path__ + "img/Info.05c8d91c.svg";